import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '../../i18n/hooks';
import { Button } from '../../ui';
import './TelegramPromoSection.css';

const TELEGRAM_FEATURES = ['feature1', 'feature2', 'feature3'];

/**
 * TelegramPromoSection - Landing promo block for Telegram notification automation
 * @param {Object} props - Component props
 * @param {Function} props.onCtaClick - CTA button click handler
 * @param {string} props.className - Additional CSS classes
 * @returns {JSX.Element} Telegram promo section
 */
const TelegramPromoSection = ({ onCtaClick, className = '' }) => {
  const { t } = useTranslation();

  return (
    <section className={`landing-telegram-promo ${className}`.trim()} aria-labelledby="telegram-promo-title">
      <div className="landing-telegram-promo__container">
        <div className="landing-telegram-promo__card">
          <div className="landing-telegram-promo__hero">
            <div className="landing-telegram-promo__icon-wrap">
              <img
                className="landing-telegram-promo__icon"
                src="/images/telegram-icon.png"
                alt=""
                width={88}
                height={88}
                loading="lazy"
                decoding="async"
              />
            </div>

            <div className="landing-telegram-promo__headline">
              <h2 id="telegram-promo-title" className="landing-telegram-promo__title">
                {t('landing.telegramPromo.title')}
              </h2>
              <p className="landing-telegram-promo__subtitle">
                {t('landing.telegramPromo.subtitle')}
              </p>
            </div>
          </div>

          <div className="landing-telegram-promo__features">
            {TELEGRAM_FEATURES.map((featureKey) => (
              <article key={featureKey} className="landing-telegram-promo__feature">
                <h3 className="landing-telegram-promo__feature-title">
                  {t(`landing.telegramPromo.${featureKey}.title`)}
                </h3>
                <p className="landing-telegram-promo__feature-description">
                  {t(`landing.telegramPromo.${featureKey}.description`)}
                </p>
              </article>
            ))}
          </div>

          <div className="landing-telegram-promo__actions">
            <Button
              variant="primary"
              size="large"
              onClick={onCtaClick}
              className="landing-telegram-promo__cta"
            >
              {t('landing.telegramPromo.cta')}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

TelegramPromoSection.propTypes = {
  onCtaClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default TelegramPromoSection;
